export const SHOP_THEME_LIST = [
  'ecommercebasic',
  'adminperform',
  'sahapan',
  'nvbb',
  'ticket',
  'bec',
  'runkan',
  'lookchingiant',
  'chatty',
  'erawon',
  'scgdistribution',
  'tero',
  'foodguru',
  'oab',
  'cityfresh',
  'warroom',
  'powerbuy',
  'powerby',
  'nestle'
]



// WEBPACK FOOTER //
// ./src/constants/shop.js